module.exports = __webpack_public_path__ + "img/frasco_inovah_1000.1cb308b3.png";